import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useForm, FormProvider} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {InputTextWrapper} from '../../../../../../components/UI/Form/Input'
import {SelectWrapper} from '../../../../../../components/UI/Form/Input'
import {getSnackBarToast} from '../../../../../../util/snackBar'
import {GuestModel} from '../../../guests/model'
import {useCentralServices} from '../../../../hooks/useCentralServices'
import {CreateGuestFaceToFaceModel} from '../../model/createGuestFaceToFace.model'
import {newFromRelay} from '../../../../../central/services'
import useEnterpriseService from '../../../../../central/hooks/useEnterpriseService'
import {getDataHuespedPopup} from '../../../../services/booking.service'
import {watch} from 'fs/promises'
import moment from 'moment'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  bedInfo: {
    huespedNombre: string
    nroReserva: string
    fechaFinProgramada: string
  }
}

const ModalInfoBedGuest: FC<Props> = ({show, setShow, bedInfo}) => {
  const handleClose = () => {
    setShow(false)
  }

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-md'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Información De Cama</h5>
          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <form>
            <div className='row p-3'>
              <div className='mb-5 col-md-12 d-flex flex-column align-items-start  justify-content-center'>
                <label className='fw-bold fs-5'>NOMBRES COMPLETOS DEL HUESPED</label>
                <div className='mt-2'>
                  <span className='fw-normal'>{bedInfo.huespedNombre}</span>
                </div>
              </div>
              <div className='mb-5 col-md-12d-flex flex-column align-items-start  justify-content-center'>
                <label className='fw-bold fs-5'>NÚMERO DE RESERVA</label>
                <div className='mt-2'>
                  <span className='fw-normal'>{bedInfo.nroReserva}</span>
                </div>
              </div>
              <div className='mb-5 col-md-12 d-flex flex-column align-items-start  justify-content-center'>
                <label className='fw-bold fs-5'>FECHA FIN PROGRAMADA</label>
                <div className='mt-2'>
                  <span className='fw-normal'>
                    {moment(bedInfo?.fechaFinProgramada || '').format('YYYY-MM-DD')}
                  </span>
                </div>
              </div>
            </div>
            <div className='d-flex justify-content-end mb-3'>
              <button type='button' className='btn btn-light-primary me-3' onClick={handleClose}>
                Cerrar
              </button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  )
}

export {ModalInfoBedGuest}
